import { useMediaQuery } from "@mui/material";
import backgroundImage from "assets/refresh.jpg";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { getIsStandalonePWA } from "components/PWA/helpers/getIsStandalonePWA";
import { useGoogleAnalyticsContext } from "contexts";
import { analyticsTrackerV2 } from "contexts/ScopelyIdentityProvider/configv2";
import { markServiceWorkerVersion } from "helpers/serviceWorker";
import { useEffect, useState } from "react";
import {
	Body,
	Button,
	ButtonsContainer,
	Container,
	Header,
	SubTitle,
	Title
} from "./styles";

export const AppUpdateAvailable = () => {
	const [isRefreshing, setIsRefreshing] = useState(false);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const isPortrait = useMediaQuery("(orientation: portrait)");
	//const scale = useCalculateScale(342 + 40, 409 + 40);
	const scale = useCalculateScale(
		isPortrait ? 363 + 40 : 956 + 40,
		isPortrait ? 613 + 40 : 410 + 40
	);

	const handleRefresh = async () => {
		if (isRefreshing) {
			return;
		}

		setIsRefreshing(true);
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "CTA_click",
			event_type: "cache_refresh_reminder_popup",
			action: "dialog_click",
			source: "general_popup_dialog",
			tag_text:
				"The Web Shop Has Been Updated Please refresh the page to continue using the latest version",
			sys_platform: getIsStandalonePWA() ? "pwa" : "web"
		});
		markServiceWorkerVersion();

		try {
			await analyticsTrackerV2.flush();
		} finally {
			window.location.reload();
		}
	};

	useEffect(() => {
		markServiceWorkerVersion();

		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "dialog_shown",
			event_type: "cache_refresh_reminder_popup",
			action: "dialog_shown",
			source: "general_popup_dialog",
			tag_text:
				"The Web Shop Has Been Updated Please refresh the page to continue using the latest version",
			sys_platform: getIsStandalonePWA() ? "pwa" : "web"
		});
	}, []);

	return (
		<Container scale={scale}>
			{/* <CloseIconButton onClose={onClose} /> */}
			<Header style={{ backgroundImage: `url(${backgroundImage})` }} />
			<Body>
				<Title>
					<div>
						The Web Shop Has
						<br /> Been Updated
					</div>
				</Title>

				<SubTitle>
					Please refresh the page to continue
					<br /> using the latest version
				</SubTitle>
				<ButtonsContainer>
					<Button
						variant="contained"
						themeColor="primary"
						onClick={handleRefresh}
						disabled={isRefreshing}
					>
						REFRESH
					</Button>
				</ButtonsContainer>
			</Body>
		</Container>
	);
};
